import React from 'react';
import classNames from 'classnames';

interface TradeInLanderCardProps {
  className?: string;
  cta: React.ReactNode;
  header: string;
  content: string;
}

const TradeInLanderCard: React.FC<TradeInLanderCardProps> = ({
  className,
  content,
  cta,
  header,
  ...props
}) => {
  return (
    <article
      className={classNames(
        className,
        'rounded-lg shadow-lg text-true-black px-4 py-3 md:px-8 md:py-6 bg-white',
      )}
      {...props}
    >
      <div className="mb-2 text-4xl font-bold">{header}</div>
      <p className="mb-4 text-lg font-semibold">{content}</p>
      {cta}
    </article>
  );
};

export default TradeInLanderCard;
